module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="dropdown-region">\n    ';
 if (userPermissionsEnabled) { ;
__p += '\n    <label>Shared with:</label>\n    ';
 } ;
__p += '\n    <div class="checkbox-region"></div>\n    <div class="dropdown">\n    </div>\n    <div class="warning-note"\n    ';
 if (userPermissionsEnabled) { ;
__p += '\n    <label>Please note: Managers have access to all experiences.</label>\n    ';
 } ;
__p += '\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experienceOverview/experiencePermissions/UserSharingPermissionsView.tpl
// module id = 2885
// module chunks = 0